import React from 'react';

// The inverse of GapNote. There the recording had the passage and the Formosan
// text did not; here the text is complete and the RECORDING is empty — four
// clips decode to a flat 0.0000 peak end to end, against room tone everywhere
// else in the same book. Nothing was aligned against them, so the word times in
// these records are arithmetic, not measurement (one Saisiyat word was credited
// 20.11 s). Say so rather than handing the learner a play button that produces
// 24 seconds of nothing and highlights one word the whole way through.
export default function SilentNote({ note }) {
  if (!note) return null;
  return (
    <div className="sv-gaps">
      <p className="sv-gap sv-silent">
        <span className="sv-gap-mark">缺</span>
        <span>{note}</span>
      </p>
    </div>
  );
}
